import {IChatMessageThreadData} from "@buildwithflux/models";
import {values} from "lodash";

import {isUntitledThreadName} from "components/pages/document/components/editor/components/right_drawer/copilot_chat/state/helpers/threadNameHelpers";
import {ICopilotChatStore} from "components/pages/document/components/editor/components/right_drawer/copilot_chat/state/useCopilotChatStore";

export function selectUntitledThreads(state: ICopilotChatStore) {
    const threadIsUntitled = (thread: IChatMessageThreadData) => !thread.name || isUntitledThreadName(thread.name);
    const allThreads = values(state.threads);
    return allThreads.filter(threadIsUntitled);
}
